export const LOGIN_REQUEST ="LOGIN_REQUEST";
export const LOGIN_SUCCESS ="LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_STUDENT = "LOGOUT_STUDENT";


export const REGISTER_USER_REQUEST ="REGISTER_USER";
